import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const names = {
    MERKDEALER_GEKOZEN_MERK: "Erkend reparateur",
    OFFICIELE_MERKDEALER: "Officiële merkdealer",
    SUBDEALER: "Subdealer",
    BOVAG_AUTOBEDRIJF: "Onafhankelijk BOVAG autobedrijf",
    UNIVERSEEL_AUTOBEDRIJF: "Universeel autobedrijf",
    PARTICULIER: "Particulier"
};

export const AanbiederFilter = ({ condensed }) => {
    const filter = useFilter("aanbiedersoort");
    const [value, , onChange] = useField("soortAanbieder");

    const options =
        filter.map((option) => ({
            id: option,
            displayName: names[option]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-aanbieder"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 3}
                datalayerKey="soortAanbieder"
                maxSize={0}
            />
        </Grid>
    );
};
